import React from 'react'
import { BrowserRouter,NavLink, Route, Routes } from 'react-router-dom';
import './App.css';
import Kidney from './components/kidney/kidney';
import DistalNephron from './components/distal_nephron/distal_nephron';
import MyeloidCells from './components/myeloid_cells/myeloid_cells';
const Home = () => <h1>Home</h1>;
function App() {
  return (
    <BrowserRouter  basename={process.env.PUBLIC_URL}>
<div>
      <NavLink  className={({ isActive }) => (isActive ? 'active' : 'inactive')} to='/kidney'>Kidney</NavLink>{' '}
      <NavLink  className={({ isActive }) => (isActive ? 'active' : 'inactive')} to='/distal_nephron'>Distal Nephron</NavLink>{' '}
      <NavLink  className={({ isActive }) => (isActive ? 'active' : 'inactive')} to='/myeloid_cells'>Myeloid Cells</NavLink>{' '}
      <Routes>
        <Route path="/kidney" element={<Kidney/>} />
        <Route path="/distal_nephron" element={<DistalNephron/>} />
        <Route path="/myeloid_cells" element={<MyeloidCells/>} />
        <Route render={() => <h1>Page not found</h1>} />
      </Routes>
</div>
</BrowserRouter>
  );
}
export default App;
